<div style="display: flex; flex-direction: column; align-items: start; justify-content: start; width: 100%;">
  <div style="flex: 1 1 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom: 20px; position: relative; width: 100%;">
    <h2 class="bold-20px-center-primary" style="margin: 0; color: #0f223e; width: 100%; text-align: center;">
      {{titleLabel}}</h2>
    <div style="display: flex !important; align-items:center !important; justify-content:right !important;
    height:fit-content !important; position: absolute; right: 0;" (click)="onCancel()">
      <img [src]="'assets/icons/crossClose.svg'" style="cursor: pointer;">
    </div>
  </div>

  <div class="light-16px-center-primary" style="margin-bottom: 15px; color: #0f223e; text-align: center; width: 100%; font-weight: 500;">
    {{ ticketName }}
  </div>

  @if (totalQuantity > 1) {
  <div class="light-14px-center-primary"
    style="margin-bottom: 15px; color: #0f223e; text-align: center; width: 100%; font-weight: 600;">
    {{ ticketIndexLabel }}
  </div>
  }

  <form [formGroup]="myForm" style="display: flex; flex-direction: column; gap: 15px; width: 100%;">
    @for (field of formFields; track field.name) {
    
    <!-- Campo de texto, email, etc. -->
    @if (field.type !== 'select' && field.type !== 'date') {
    <div style="flex: 1 1 100%;">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>{{field.webName}}</mat-label>
        <input matInput [type]="getInputType(field.type)" [formControlName]="field.name" [required]="field.required" [placeholder]="field.webName">
        @if (myForm.get(field.name)?.hasError('required') && myForm.get(field.name)?.touched) {
        <mat-error>
          {{requiredFieldLabel}}
        </mat-error>
        }
        @if (field.type === 'email' && myForm.get(field.name)?.hasError('email') && myForm.get(field.name)?.touched && !myForm.get(field.name)?.hasError('required')) {
        <mat-error>
          {{invalidEmailLabel}}
        </mat-error>
        }
      </mat-form-field>
    </div>
    }

    <!-- Campo de fecha -->
    @if (field.type === 'date') {
    <div style="flex: 1 1 100%;">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>{{field.webName}}</mat-label>
        <input matInput [type]="field.type" [formControlName]="field.name" [required]="field.required" [placeholder]="field.webName">
        @if (myForm.get(field.name)?.hasError('required') && myForm.get(field.name)?.touched) {
        <mat-error>
          {{requiredFieldLabel}}
        </mat-error>
        }
      </mat-form-field>
    </div>
    }

    <!-- Campo select -->
    @if (field.type === 'select') {
    <div style="flex: 1 1 100%;">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>{{field.webName}}</mat-label>
        <mat-select [formControlName]="field.name" [required]="field.required">
          @for (option of field.options; track $index) {
          <mat-option [value]="option.name || option">
            {{option.name || option}}
          </mat-option>
          }
        </mat-select>
        @if (myForm.get(field.name)?.hasError('required') && myForm.get(field.name)?.touched) {
        <mat-error>
          {{requiredFieldLabel}}
        </mat-error>
        }
      </mat-form-field>
    </div>
    }

    }

    <div style="margin-top: 10px; width: 100%; display: flex; justify-content: center;">
      <button mat-raised-button (click)="onConfirm()" [disabled]="!myForm.valid"
        class="primary-background regular-16px-center-white">
        {{confirmLabel}}
      </button>
    </div>
  </form>
</div>